import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { map, finalize } from 'rxjs/operators';
import { FirestoreService } from './firestore.service';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  ref: AngularFireStorageReference;
  task: AngularFireUploadTask;
  uploadState: Observable<string>;
  uploadProgress: Observable<number | null>;
  downloadUrl: Observable<string>;
 
  constructor(
    private db: FirestoreService,
    private storage: AngularFireStorage,
    private firestore: AngularFirestore

  ) { }
  
  async uploadPDFPicture(generatedFileName, pdfFile: File, pictureFile: File, docData: object, mainColId, mainDocId, subColId): Promise<void> {
    //const generatedFileName = `pulication-${Date.now()}`;
    const pdfFilePath = `${mainColId}/${mainDocId}/${subColId}/${generatedFileName}.pdf`;
    const pictureFilePath = `${mainColId}/${mainDocId}/${subColId}/${generatedFileName}.jpg`;
   
    if (pdfFile && pictureFile) {
      try {
        await this.uploadFileToStorage(pdfFilePath, pdfFile);
        const pdfUrl = await this.getFileDownloadUrl(pdfFilePath);
        await this.uploadFileToStorage(pictureFilePath, pictureFile);
        const pictureUrl = await this.getFileDownloadUrl(pictureFilePath);
        await this.savePDFPictureFirestore(pdfUrl, pictureUrl, docData, mainColId, mainDocId, subColId);
      } catch (error) {
        throw error;
      }
      
    }else{
      try {
        await this.uploadFileToStorage(pdfFilePath, pdfFile);
        const pdfUrl = await this.getFileDownloadUrl(pdfFilePath);       
        await this.savePDFFirestore(pdfUrl, docData, mainColId, mainDocId, subColId);
      } catch (error) {
        throw error;
      }
    } 
    
  }
  async uploadPicture(generatedFileName, pictureFile: File, docData: object, mainColId, mainDocId, subColId): Promise<void> {
    //const generatedFileName = `media-release-${Date.now()}`;
    const pictureFilePath = `${mainColId}/${mainDocId}/${subColId}/${generatedFileName}.jpg`;   
    if (pictureFile) {
      try {
        await this.uploadFileToStorage(pictureFilePath, pictureFile);
        const pictureUrl = await this.getFileDownloadUrl(pictureFilePath);
        await this.savePictureFirestore(pictureUrl, docData, mainColId, mainDocId, subColId);
      } catch (error) {
        throw error;
      }
      
    }else{
      try {    
        await this.saveMetadataFirestore( docData, mainColId, mainDocId, subColId);
      } catch (error) {
        throw error;
      }
    } 
    
  }

  private async uploadFileToStorage(filePath: string, file: File): Promise<void> {    
    try {
      await this.storage.upload(filePath, file);
    } catch (error) {
      throw error;
    }
  }
  private async getFileDownloadUrl(filePath: string): Promise<string> {
    try {
      const ref = this.storage.ref(filePath);
      return await ref.getDownloadURL().toPromise();
    } catch (error) {
      throw error;
    }
  }
  private async savePDFPictureFirestore(pdfUrl: string, pictureUrl: string, docData, mainColId, mainDocId, subColId): Promise<void> {
    try {
      await this.firestore.collection(mainColId).doc(mainDocId).collection(subColId).add({ pdfUrl, pictureUrl, ...docData });
    } catch (error) {
      throw error;
    }
  }
  private async savePDFFirestore(pdfUrl: string, docData, mainColId, mainDocId, subColId): Promise<void> {
    try {
      await this.firestore.collection(mainColId).doc(mainDocId).collection(subColId).add({ pdfUrl, ...docData });
    } catch (error) {
      throw error;
    }
  }
  private async savePictureFirestore(pictureUrl: string, docData, mainColId, mainDocId, subColId): Promise<void> {
    try {
      await this.firestore.collection(mainColId).doc(mainDocId).collection(subColId).add({ pictureUrl, ...docData });
    } catch (error) {
      throw error;
    }
  }  
  private async saveMetadataFirestore(docData, mainColId, mainDocId, subColId): Promise<void> {
    try {
      await this.firestore.collection(mainColId).doc(mainDocId).collection(subColId).add({ ...docData });
    } catch (error) {
      throw error;
    }
  }
  // private async savePDFTextToFirestore(pdfUrl: string, textData, mainColId, mainDocId, subColId): Promise<void> {
  //   try {
  //     await this.firestore.collection(mainColId).doc(mainDocId).collection(subColId).add({ pdfUrl, ...textData });
  //   } catch (error) {
  //     throw error;
  //   }
  // }
  async deletePDFPicture(fileUrl, pictureUrl, mainColId, mainDocId, subColId, subDocId){
    if(fileUrl && pictureUrl){
      await this.storage.storage.refFromURL(fileUrl).delete()
      await this.storage.storage.refFromURL(pictureUrl).delete()
      await this.firestore.collection(mainColId).doc(mainDocId)
      .collection(subColId).doc(subDocId)
      .delete();    
    }else{
      await this.storage.storage.refFromURL(fileUrl).delete()
      await this.firestore.collection(mainColId).doc(mainDocId)
        .collection(subColId).doc(subDocId)
        .delete();
    }   
  }
  async deletePicture(pictureUrl, mainColId, mainDocId, subColId, subDocId){
    if(pictureUrl){
      await this.storage.storage.refFromURL(pictureUrl).delete()
      await this.firestore.collection(mainColId).doc(mainDocId)
      .collection(subColId).doc(subDocId)
      .delete();    
    }else{
      await this.firestore.collection(mainColId).doc(mainDocId)
        .collection(subColId).doc(subDocId)
        .delete();
    }   
  }

  

  //#################################################

  uploadPdf(file: File, fileName, mainColId, mainDocId, subColId): Observable<string | null> {   
    const filePath = `${mainColId}/${mainDocId}/${subColId}/${fileName}`;
    const fileRef = this.storage.ref(filePath);
    const uploadTask = this.storage.upload(filePath, file);
    this.uploadProgress = uploadTask.percentageChanges();

    return new Observable<string | null>((observer) => {
      uploadTask
        .snapshotChanges()
        .pipe(
          finalize(() => {
            fileRef.getDownloadURL().subscribe(
              (url) => {
                console.log(url);                
                observer.next(url);
                observer.complete();
              },
              (error) => {
                observer.error(error);
                observer.complete();
              }
            );
          })
        )
        .subscribe();
    });
  }

  getUploadProgress(): Observable<number | null> {   
    return this.uploadProgress;
  }
  
  upload(event) {
    const id = Math.random().toString(36).substring(2);
    this.ref = this.storage.ref(id);
    this.task = this.ref.put(event.target.files[0]);
    this.uploadState = this.task.snapshotChanges().pipe(map(s => s.state));
    this.uploadProgress = this.task.percentageChanges();    
    this.task.snapshotChanges().pipe(
      finalize(() => this.downloadUrl = this.ref.getDownloadURL() )
   )
  .subscribe()
  }
  
  // File: people/uid/profilePictures : MainFolder/SubFolder/SubSubFolder
  // Data: people/uid/profilePictures : MainCol/MainDoc/SubCol
  uploadFileSubSubFolderSubCol(file, mainDocKeyId, subColKeyId, mainColId, mainDocId, subColId){
    // Upload
    const id = Math.random().toString(36).substring(2);
    const path = `${mainColId}/${mainDocId}/${subColId}/${id}`
    this.ref = this.storage.ref(path);
    this.task = this.storage.upload(path, file)
    //Progress
    this.uploadState = this.task.snapshotChanges().pipe(map(s => s.state));
    this.uploadProgress = this.task.percentageChanges();    
    // DownloadUrl
    this.task.snapshotChanges().pipe(
      finalize(() => {
        this.ref.getDownloadURL().subscribe(downloadUrl => {            
        this.downloadUrl = downloadUrl;
        this.db.setMainDocaddSubCol(this.downloadUrl, mainDocKeyId, subColKeyId, mainColId, mainDocId, subColId)
        //console.log(this.downloadUrl);        
       }) 
      })
   )
    .subscribe()
    //console.log(this.task, this.uploadProgress, this.downloadUrl);  
    return this.task.percentageChanges();
  }

  deleteFile(pictureUrl){
    return this.storage.storage.refFromURL(pictureUrl).delete()
    .then(res =>{
      //this.reloadComponent();  
    });
  }

  

}